// @ts-nocheck

'use client'

import React from 'react'

import { algoliasearch } from 'algoliasearch'
import { InstantSearch, Index, Configure } from 'react-instantsearch'


import { Container, SpacerBase } from '../../atoms/GridSystem'
import { Paragraph } from '../../atoms/Typography/Typography.component'

import AlgoliaSearchBox from '../../molecules/AlgoliaComponents/AlgoliaSearchBox/AlgoliaSearchBox.component'
import AlgoliaHits from '../../molecules/AlgoliaComponents/AlgoliaHits/AlgoliaHits.component'
import AlgoliaPagination from '../../molecules/AlgoliaComponents/AlgoliaPagination/AlgoliaPagination.component'
import { VirtualHitsPerPage } from '../../molecules/AlgoliaComponents/AlgoliaVirtualComponents/AlgoliaVirtualComponents.component'
import AlgoliaNoResultsBoundary from '../../molecules/AlgoliaComponents/AlgoliaNoResultsBoundary/AlgoliaNoResultsBoundary.component'
import AlgoliaNoResultsComponent from '../../molecules/AlgoliaComponents/AlgoliaNoResultsComponent/AlgoliaNoResultsComponent.component'
import AlgoliaEmptyQueryBoundary from '../../molecules/AlgoliaComponents/AlgoliaEmptyQueryBoundary/AlgoliaEmptyQueryBoundary.component'

import SectionBuilder from '../../organisms/SectionBuilder/SectionBuilder.component'

import { getPageLocale } from '@caffeina-siad/utils'
import { useTranslations } from 'next-intl';

import * as S from './styles'
import { getAlgoliaSearchFilters } from './AlgoliaSearchFilters'

export interface AlgoliaIndex {
  indexName: string
  label: string
  isSiteScoped: boolean
  initialUiState: {
    page: number
    hitsPerPage: number
  }
}

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
)

function AlgoliaSearch({ sections }) {
  const t = useTranslations();
  const locale = getPageLocale()
  const site = process.env.NEXT_PUBLIC_SITE_NAME

  const indexes: AlgoliaIndex[] = [
    {
      indexName: 'page',
      label: t('search.pageLabel'),
      isSiteScoped: true,
      initialUiState: {
        page: 1,
        hitsPerPage: 3
      }
    },
    {
      indexName: 'news',
      label: t('search.newsLabel'),
      isSiteScoped: false,
      initialUiState: {
        page: 1,
        hitsPerPage: 3
      }
    },
    {
      indexName: 'document',
      label: t('search.documentLabel'),
      isSiteScoped: true,
      initialUiState: {
        page: 1,
        hitsPerPage: 3
      }
    },
  ]

  const initialUiState = indexes.reduce((acc, currentItem) => {
    acc[currentItem.indexName] = currentItem.initialUiState
    return acc
  }, {})

  return (
    <S.AlgoliaSearch colorScheme={'green'} as="section">
      <InstantSearch
        searchClient={searchClient}
        initialUiState={initialUiState}
        future={{
          preserveSharedStateOnUnmount: true,
        }}
      >
        <AlgoliaSearchBox />

        {/* <RefinementList attribute="magazine" /> */}

        <AlgoliaEmptyQueryBoundary fallback={<SectionBuilder data={sections} />}>
          {indexes.map(({ indexName, label, isSiteScoped }) => (
            <Index key={indexName} indexName={indexName}>
              <Configure filters={getAlgoliaSearchFilters({ locale, site, isSiteScoped })} />
              <Container>
                <Paragraph typo="headingXL" content={label} weight="semibold" />
                <AlgoliaNoResultsBoundary fallback={<AlgoliaNoResultsComponent entity={indexName} />}>
                  <SpacerBase xs={3} />
                  <AlgoliaHits entity={indexName} label={label} />
                  <AlgoliaPagination />
                  <VirtualHitsPerPage items={[{ label: '3 risultati per pagina', value: 3, default: true }]} />
                </AlgoliaNoResultsBoundary>
                <SpacerBase xs={5} />
              </Container>
            </Index>
          ))}
        </AlgoliaEmptyQueryBoundary>

      </InstantSearch>
    </S.AlgoliaSearch>
  )
}

export default AlgoliaSearch
